/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { setToast } from '../../../store/ToastManagement';
import {
  Container,
  Grid,
  Segment,
  Header,
  Checkbox,
  Radio,
  Dropdown,
  Embed,
  Modal
} from 'semantic-ui-react';
import { Button } from 'formik-semantic-ui';
import { useCurrentUser } from '../../../_services/hooks/user';
import {
  authAPI,
  servicesAPI,
  useCustomer,
  useCustomerPreferences
} from '../../../_services';
import {
  AONLink,
  AONButton,
  AONCheckBox,
  AONRadioButtons,
  AONOnboardTask,
  AONTimeRange,
  AONNav
} from '../../../_components/layout/AON';

import '../customerDetail_styles.css';
import '../../../_components/layout/AON.css';

const Config = require('../../../conf');

export const HUBToAONSelect = () => {
  return (
    <Container>
      <Modal open={true} size="small" style={{ padding: '20px' }}>
        <Modal.Content>
          <Header as="h2" textAlign="left">
            Please select the product you wish to use
          </Header>
          <br />
          <br />
          <Button basic color="olive" onClick={() => {
            document.location.href = '/customer/charging';
          }}>
            HUB
          </Button>
          <Button basic color="olive" onClick={() => {
            document.location.href = '/customer/dashboard';
          }}>
            Home
          </Button>
        </Modal.Content>
      </Modal>
    </Container>
  );
};
